import React from "react";

export const SuspensePreloader = () => {
    return <div className="suspense-preloader"></div>
}